module.exports = __webpack_public_path__ + "img/csss_bordeaux.33559364.webp";